import { observer } from "mobx-react-lite";
import { useTranslation } from "../i18n/useTranslation.js";
import SectionHeading from "../components/SectionHeading.js";
import { ROADMAP_ITEMS } from "../content/landingContent.js";

const RoadmapPage = observer(() => {
  const { t } = useTranslation();
  return (
    <article className="landing-page">
      <SectionHeading eyebrow={t("landing.roadmap.eyebrow")} title={t("landing.roadmap.title")}
        body={t("landing.roadmap.lead")} />
      <ol className="landing-roadmap">
        {ROADMAP_ITEMS.map((item) => (
          <li key={item.titleKey}>
            <span className="landing-roadmap-index">{item.index}</span>
            <div>
              <p className="landing-roadmap-status">{t(item.statusKey)}</p>
              <h2>{t(item.titleKey)}</h2>
              <p>{t(item.bodyKey)}</p>
            </div>
          </li>
        ))}
      </ol>
      <p className="landing-roadmap-note">{t("landing.roadmap.note")}</p>
    </article>
  );
});

export default RoadmapPage;
